let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gKB7z")).then(() => parcelRequire('4948p'));